import React from "react";
import Empty from "antd/es/empty";
import Descriptions from "antd/es/descriptions";
import { useIntl } from "react-intl";

export default function LandlordInfo({ landlord }) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const formatBoolean = (v) =>
    v == null ? "-" : t(v ? "rules-value-yes" : "rules-value-no");

  const formatAddress = () => {
    if (!landlord) return "-";
    const parts = [
      landlord.street,
      landlord.house_number,
      landlord.apartment_number ? `/${landlord.apartment_number}` : "",
    ]
      .filter(Boolean)
      .join(" ");
    const cityLine = [landlord.postal_code, landlord.city]
      .filter(Boolean)
      .join(" ");
    const provinceLine = landlord.province;
    const countryLine = landlord.country;

    return (
      [parts, cityLine, provinceLine, countryLine].filter(Boolean).join(", ") ||
      "-"
    );
  };

  if (!landlord) {
    return <Empty className="empty-sign" description={t("select-rental")} />;
  }

  const items = [
    // Identity
    { key: "name", label: t("landlord-name"), value: landlord.name },
    { key: "nip", label: t("landlord-nip"), value: landlord.nip || "-" },
    { key: "user", label: t("landlord-user"), value: landlord.user || "-" },
    {
      key: "legal_status",
      label: t("landlord-legal-status"),
      value: landlord.legal_status || "-",
    },
    // Financial
    {
      key: "vat_taxpayer",
      label: t("landlord-vat-taxpayer"),
      value: formatBoolean(landlord.vat_taxpayer),
    },
    {
      key: "vat_rate",
      label: t("landlord-vat-rate"),
      value: landlord.vat_rate || "-",
    },
    {
      key: "self_invoicing",
      label: t("landlord-self-invoicing"),
      value: formatBoolean(landlord.self_invoicing),
    },
    {
      key: "combine_payouts",
      label: t("landlord-combine-payouts"),
      value: formatBoolean(landlord.combine_payouts),
    },
    {
      key: "invoice_per_settlement",
      label: t("landlord-invoice-per-settlement"),
      value: formatBoolean(landlord.invoice_per_settlement),
    },
    // VAT Registry
    {
      key: "is_reported_to_office",
      label: t("landlord-is-reported"),
      value: formatBoolean(landlord.is_reported_to_office),
    },
    // Banking
    {
      key: "bank_account_number",
      label: t("landlord-bank-account"),
      value: landlord.bank_account_number || "-",
    },
    {
      key: "reported_bank_account_number",
      label: t("landlord-reported-bank-account"),
      value: landlord.reported_bank_account_number || "-",
    },
    // Settings
    {
      key: "should_receive_invoice_email",
      label: t("landlord-receive-invoice-email"),
      value: formatBoolean(landlord.should_receive_invoice_email),
    },
    // Contact
    {
      key: "phone_number",
      label: t("landlord-phone"),
      value: landlord.phone_number || "-",
    },
    // Address
    { key: "address", label: t("landlord-address"), value: formatAddress() },
  ].filter((item) => item.value && item.value !== "-");

  return (
    <div style={{ maxWidth: 750 }}>
      <Descriptions
        title={`${t("landlord-info")} - ${landlord.name}`}
        layout="horizontal"
        column={1}
        bordered
        size="small"
      >
        {items.map((item) => (
          <Descriptions.Item key={item.key} label={item.label}>
            {item.value}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </div>
  );
}
